import { useState } from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@mui/material';

export type DisplayType = 'list' | 'grid' | 'carousel';

interface Props {
  displayType: DisplayType;
  onChange: (displayType: DisplayType) => void;
}

const DisplayType = ({ onChange }: Props) => {
  const [type, setType] = useState<DisplayType>('list');

  const handleChange = (e) => {
    // Update local state
    setType(e.target.value);

    // Update block
    onChange((props: unknown) => {
      props.displayType = e.target.value;
      return props;
    });
  };

  return (
    <FormControl size="small" component="fieldset">
      <RadioGroup value={type} onChange={handleChange}>
        <FormControlLabel
          label="Lista"
          value="list"
          control={<Radio size="small" color="primary" />}
        />
        <FormControlLabel
          label="Grid"
          value="grid"
          control={<Radio size="small" color="primary" />}
        />
        <FormControlLabel
          label="Carousel"
          value="carousel"
          control={<Radio size="small" color="primary" />}
        />
      </RadioGroup>
    </FormControl>
  );
};

export default DisplayType;
